export const dateFormats = {
    date_YMDtHM: "yyyy-MM-dd'T'HH:mm",
    default_zone: "UTC",
    time_HM: "HH:mm",

  };